module.exports = __webpack_public_path__ + "static/media/build-outstanding-portfolio.05484b5a.png";